import React from 'react';
import { styled } from '../../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerWrap, 
    ContainerGutter,
} from '../../../../components-core/packages/components-core/dist/container';

//STYLE
import { Text, TextAppearance, TextColor } from '../../../../components-core/packages/components-core/dist/text';


class ResultRow extends React.Component {

    render() {
        return (
            <Container wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0100}>
                <Text appearance={TextAppearance.copy0200} color={TextColor.secondary} >
                    Aktivasyon Kodu: 
                    <Text appearance={TextAppearance.copy250} color={TextColor.primary} bold> r3535</Text>
                </Text>
                <Text appearance={TextAppearance.copy0200}>
                    Aracınıza yönelik aşağıdaki servis aksiyonu bulunmaktadır. 
                    Lütfen en yakın zamanda bir Volkswagen Yetkili Servisi’ne başvurunuz.
                </Text>
                <Text appearance={TextAppearance.copy0200} bold>Tamamlandı</Text>
            </Container>
        )
    }
}

export default ResultRow;